<template>
  <nav class="navbar navbar-dark bg-dark">
    <a href="/">
      <img src="/logo-text-small.png" height="38" alt="just bookmark it!" class="d-none d-sm-inline"/>
      <img src="/logo-only-small.png" height="38" alt="just bookmark it!" class="d-sm-none"/>
    </a>
    <div class="dropdown">

      <a v-if="!userLoggedIn"
         class="mr-3 btn btn-cta btn-cta-small"
         data-toggle="modal"
         data-target="#registerEmailModal">Sign up</a>

      <router-link  v-if="userLoggedIn" class="mr-3 d-none d-sm-inline" :to="'/search/'+loggedInUserName"><i class="bi bi-search mr-2 icon-grow tl-navbar-icon"/></router-link>
      <router-link class="mr-3 d-none d-sm-inline" to="/help"><i class="bi bi-question-circle icon-grow tl-navbar-icon"></i></router-link>
      <button class="navbar-toggler" type="button" data-toggle="dropdown">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div v-if="userLoggedIn" class="dropdown-menu dropdown-menu-right dropdown-menu-dark">
        <router-link class="dropdown-item" to="/mybookmarks"><i class="bi bi-bookmark-star-fill text-primary mr-2"/>my bookmarks</router-link>
        <router-link class="dropdown-item" :to="'/tags/'+loggedInUserName+'/tagcloud'"><i class="bi bi-tags-fill text-warning mr-2"/>my tags</router-link>
        <router-link class="dropdown-item" :to="'/discover'"><i class="bi bi-people-fill mr-2 text-danger"/>discover</router-link>
        <router-link class="dropdown-item" :to="'/search/'+loggedInUserName"><i class="bi bi-search mr-2"/>search</router-link>
        <router-link class="dropdown-item" :to="'/imports'"><i class="bi bi-cloud-arrow-up-fill text-info mr-2"/>imports</router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/help"><i class="bi bi-question-circle mr-2"></i>help</router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/profile"><i class="bi bi-person-vcard mr-2"></i>my profile</router-link>
        <a class="dropdown-item signout-link" href="#" @click="logout"><i class="bi bi-x-square mr-2"></i>sign out {{ loggedInUserName }}</a>
      </div>

      <div v-if="!userLoggedIn" class="dropdown-menu dropdown-menu-right dropdown-menu-dark">
        <router-link class="dropdown-item" :to="'/discover'"><i class="bi bi-people-fill mr-2 text-danger"/>discover</router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/mybookmarks">sign in</router-link>
      </div>

  </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "NavBar",
  computed: mapState(['userLoggedIn', 'loggedInUserName']),
  methods: {
    logout(event) {
      event.preventDefault();
      this.$store.commit("logoutUser");
      this.$router.push({ name: "mylinks" });
    }
  }
};
</script>

<style scoped>
.navbar {
  border-bottom: 2px solid #ffc107;
  background: linear-gradient(0deg, #343a40, #333) !important;
  z-index: 1031;
}

.tl-navbar-icon {
  font-size: 1.3em;
  color: rgba(255, 255, 255, .5);
}

.dropdown-menu-dark {
  color: #dee2e6;
  background-color: #343a40;
  background: linear-gradient(90deg, #343a40, #333);
  border-color: rgba(0, 0, 0, .15);
  box-shadow: 3px 3px 3px 0px rgba(100, 100, 100, 0.2);
}

.dropdown-menu-dark .dropdown-item {
  color: #dee2e6;
}

.dropdown-menu-dark .dropdown-item:focus, .dropdown-menu-dark .dropdown-item:hover {
  color: rgb(255, 255, 255);
  background-color: rgba(255, 255, 255, 0.15);
}

.signout-link {
  color: coral !important;
}

</style>
